import { Component, OnInit } from '@angular/core';
import { ChartType, ChartDataset } from 'chart.js';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.css']
})
export class DoughnutChartComponent implements OnInit {

  public doughnutChartLabels: string[] = ['Process 1', 'Process 2', 'Process 3', 'Process 4', 'Process 5', 'Process 6'];
  public doughnutChartDatasets: ChartDataset<'doughnut'>[] = [{ data: [30, 50, 20, 5, 50, 15] }];
  public doughnutChartType: 'doughnut' = 'doughnut';

  constructor() { }

  ngOnInit(): void {
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

}
